// extracted by mini-css-extract-plugin
export default {"container":"ItemGroupListPage_container__n2u5q"};